<template>
  <b-card
    class="p-2 h-100 leaderboard-card"
    body-class="px-3"
    footer-class="bg-white pb-0"
  >
    <b-row class="pb-3 border-bottom">
      <b-col class="block-title" cols="6">Leaderboard</b-col>
      <b-col
        v-if="leaderboard && leaderboard.userScore"
        class="text-right"
        cols="6"
      ><b>{{ leaderboard.userScore.total || 0 }}</b> points earned</b-col>
    </b-row>
    <b-row class="pb-3 border-bottom">
      <b-col cols="12" md="4">
        <div
          class="text-center py-2"
          v-if="prizes && prizes.second && prizes.second.title"
        ><b>1st</b></div>
        <div>
          <b-img
            v-if="prizes && prizes.first && prizes.first.image && prizes.first.image.fileLocation"
            :src="prizes.first.image.fileLocation"
            fluid
          />
        </div>
        <div
          class="text-center pt-2"
          v-if="prizes && prizes.first && prizes.first.title"
        >{{ prizes.first.title }}</div>
      </b-col>
      <b-col cols="12" md="4">
        <div
          class="text-center py-2"
          v-if="prizes && prizes.second && prizes.second.title"
        ><b>2nd</b></div>
        <div>
          <b-img
            v-if="prizes && prizes.second && prizes.second.image && prizes.second.image.fileLocation"
            :src="prizes.second.image.fileLocation"
            fluid
          />
        </div>
        <div
          class="text-center pt-2"
          v-if="prizes && prizes.second && prizes.second.title"
        >{{ prizes.second.title }}</div>
      </b-col>
      <b-col cols="12" md="4">
        <div
          class="text-center py-2"
          v-if="prizes && prizes.second && prizes.second.title"
        ><b>3rd</b></div>
        <div>
          <b-img
            v-if="prizes && prizes.third && prizes.third.image && prizes.third.image.fileLocation"
            :src="prizes.third.image.fileLocation"
            fluid
          />
        </div>
        <div
          class="text-center pt-2"
          v-if="prizes && prizes.third && prizes.third.title"
        >{{ prizes.third.title }}</div>
      </b-col>
    </b-row>
    <b-row v-if="leaderboard.userScores && Array.isArray(leaderboard.userScores.edges)">
      <b-col cols="12">
        <b-row
          v-for="({ entry, total }, index) in leaderboard.userScores.edges.slice(0,5)"
          :key="`${index}-key`"
          class="py-3"
          :class="{ 'border-bottom': index < leaderboard.userScores.edges.slice(0,5).length - 1 }"
        >
          <b-col cols="2">{{ index+1 }}</b-col>
          <b-col cols="6">{{ entry.fullName }}</b-col>
          <b-col cols="4"><b>{{ total || 0 }}</b> pts</b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- view more button -->
    <div
      class="text-center"
      slot="footer">
      <b-link
        class="p-0"
        variant="primary-link"
        :to="{ name: 'LeaderboardIndex'}"
      >
        <b>View More Leaderboards</b>
      </b-link>
    </div>
  </b-card>

</template>

<script>
import tinycolor from 'tinycolor2';
import { mapRoot } from '@src/mixins/root';

export default {
  props: {
    leaderboard: {
      type: Object,
    },
  },
  computed: {
    ...mapRoot([ 'company', 'user', 'isLoggedIn', 'isRecruiter' ]),
    background() {
      const { siteBranding } = this.company;
      return siteBranding && siteBranding.primaryColour ? tinycolor(siteBranding.primaryColour).lighten(42).toString() : '#eee';
    },
    prizes() {
      const { prizes } = this.leaderboard;
      return prizes;
    }
  },
};
</script>

<style lang="scss">
.leaderboard-card {
  .block-title {
    text-transform: uppercase;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Leaderboard.vue